export const UPDATE_ORDER = "orderInProgress/UPDATE_ORDER";
export const PLACE_ORDER = "orderInProgress/PLACE_ORDER";
export const PLACE_ORDER_SUCCESS = "orderInProgress/PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAIL = "orderInProgress/PLACE_ORDER_FAIL";
